export default __webpack_public_path__ + "static/media/icon-water-softner.ac10da40.svg";